export default "__VITE_ASSET__DRP4WiGY__"